import { forwardRef, type HTMLAttributes } from 'react';

export interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  title?: string
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  ({ title, children, className = '', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`relative bg-black/85 rounded-xl p-4 backdrop-blur-md shadow-lg min-w-[200px] ${className}`}
        style={{ overflow: 'visible' }}
        {...props}
      >
        {title && (
          <h3 className="text-white text-sm font-medium text-center mb-3 pb-2 border-b border-white/10">
            {title}
          </h3>
        )}
        {children}
      </div>
    )
  }
)

Panel.displayName = 'Panel'
